import { createFifoCache } from '@ardoq/common-helpers';
import { GRAPH_ITEM_LABEL_CACHE_SIZE } from '@ardoq/global-consts';

const canvasLabelMeasurer = (
  font: string,
  cacheSize = GRAPH_ITEM_LABEL_CACHE_SIZE
) => {
  const canvas = new OffscreenCanvas(0, 0);
  const context = canvas.getContext('2d');
  if (!context) {
    return () => NaN; // 💣
  }
  context.font = font;
  return createFifoCache(
    cacheSize,
    (text: string) => context.measureText(text).width
  );
};

export { canvasLabelMeasurer };
